import React, { useEffect, useState, useRef } from "react";
import MainLayout from "../nav/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import "./UserManagement.scss";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../auth/Login";
import Footer from "../reusables/Footer";
import { getToken } from "../auth/authConfig";
import LandingPage from "../Layout/Options/LandingPage";
const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};



export default function OptionsAdditions() {
  const [loadingUser, setloadingUser] = useState(false);
  const [userinfo, setuserinfo] = useState({});
  const [pageDetails, setPageDetails] = useState();
  const [error, seterror] = useState(false);
  const [errorCode, seterrorCode] = useState();

  const getUserinfo = async () => {
    setloadingUser(true);
    const url = `${process.env.REACT_APP_SERVER_URL}/api/user/getUserInfoV2`;
    const token = await getToken();

    await fetch(`${url}`, {
      headers: {
        "oidc-token": token,
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          response.json().then((json) => {
            setloadingUser(false);
            setuserinfo(json?.user);

            const info = json?.user;
            const role = info?.group_name;
            const company = info?.company;
            setPageDetails(role);
            localStorage.setItem("GroupName", role);
            localStorage.setItem("company", company);
          });
        } else if (response.status === 401) {
          setloadingUser(false);
          seterror(true);
          console.log(typeof response.status);
          seterrorCode(response.status);
        } else if (response.status === 403) {
          setloadingUser(false);
          seterror(true);
          console.log(response.status);
          seterrorCode(response.status);
        } else if (response.status === 500) {
          setloadingUser(false);
          seterror(true);
          console.log(response.status);
          seterrorCode(response.status);
        } else if (response.status === 404) {
          setloadingUser(false);
          seterror(true);
          console.log(response.status);
          seterrorCode(404);
        }
      })
      .catch((err) => {
        setloadingUser(false);
      });
  };

  useEffect(() => {
    getUserinfo();
  }, []);

  return (
    <>
      <AuthenticatedTemplate>
        <div id="userManagement" style={{ position: "relative" }}>
          <Box className="mainLayout" sx={{ display: "flex" }}>
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              {/* <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} /> */}

              <div id="mainHome" style={{ overflowY: "auto", height: "auto" }}>
               <LandingPage/>

                <Footer />
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
}
